var link = document.createElement('link');
link.setAttribute('rel', 'manifest');
link.setAttribute('href', __webpack_public_path__ + "static/appmanifest.79c8be3a682f8272a7116a8e3c8cfc5b.json");
document.head.appendChild(link);
var manifest = {"name":"Docendo","short_name":"Docendo","theme_color":"#468ad7","background_color":"#468ad7","display":"standalone","icons":[{"src":"/app/static/icons/icon-72x72.f584413a724fc454007b3560d1c15b9d.png","sizes":"72x72","type":"image/png"},{"src":"/app/static/icons/icon-96x96.0e05086c44641ea344a819b88585ab47.png","sizes":"96x96","type":"image/png"},{"src":"/app/static/icons/icon-128x128.a855fd0e0c747c8095602abe2ef87059.png","sizes":"128x128","type":"image/png"},{"src":"/app/static/icons/icon-144x144.c7242051565445c99d4cd9f37db9da1f.png","sizes":"144x144","type":"image/png"},{"src":"/app/static/icons/icon-152x152.5b92e6ea3021ee7fe29ce0dbdf6162e9.png","sizes":"152x152","type":"image/png"},{"src":"/app/static/icons/icon-192x192.ebb3986f7be6530b978af6b82f44d8f3.png","sizes":"192x192","type":"image/png"},{"src":"/app/static/icons/icon-384x384.41378a54e0b40578c27271d92cc6b77d.png","sizes":"384x384","type":"image/png"},{"src":"/app/static/icons/icon-512x512.09293af4c248bb63ac6ebc0c27ef193e.png","sizes":"512x512","type":"image/png"}],"splash_pages":null};
if(manifest.icons && manifest.icons.length){
  for(var i in manifest.icons){
    var link = document.createElement('link');
    link.setAttribute('rel', 'apple-touch-icon');
    link.setAttribute('sizes', manifest.icons[i].sizes);
    link.setAttribute('href', manifest.icons[i].src);
    document.head.appendChild(link);
  }
}
if(manifest.display && (manifest.display == 'fullscreen' || manifest.display == 'standalone')){
  var meta = document.createElement('meta');
  meta.setAttribute('name', 'apple-mobile-web-app-capable');
  meta.setAttribute('content', 'yes');
  document.head.appendChild(meta);
}
if(manifest.theme_color){
  var meta = document.createElement('meta');
  meta.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
  meta.setAttribute('content', manifest.theme_color);
  document.head.appendChild(meta);
}



//////////////////
// WEBPACK FOOTER
// ./src/appmanifest.json
// module id = 2177
// module chunks = 1